import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Endpoints } from 'src/app/core/resources/endpoints';
import { Global } from 'src/app/core/resources/global';
import { Subject } from 'rxjs';
import { environment } from './../../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ValidationService {


    constructor(private _http: HttpClient, private _endpointResources: Endpoints, private _globalResources: Global) { }
    
    public updateCompany(params: any) {
        return this._http.put(
            environment.urlServerTeclogi + this._endpointResources.urlUpdateCompany,
            params
        );
    }

    public downloadFile(url: string) {
        return this._http.get(
            url, { responseType: 'blob' }
        );
    }
}
